import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "@themesberg/react-bootstrap";

import { Routes } from "../../../routes";
import Privacy from "../../commons/privacy/Privacy";
import SupportContactSettings from "../contact/SupportContactSettings";

const TABS = [
  { key: "privacy", label: "Điều khoản sử dụng" },
  { key: "contact", label: "Liên hệ" },
];

export default () => {
  const location = useLocation();
  const [tab, setTab] = useState(
    location.pathname === Routes.SettingContact.path ? "contact" : "privacy"
  );

  return (
    <>
      <Nav
        variant="tabs"
        className="mb-3 mt-3"
        activeKey={tab}
        onSelect={(k) => setTab(k)}
      >
        {TABS.map((t) => (
          <Nav.Item key={t.key}>
            <Nav.Link eventKey={t.key}>{t.label}</Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      {tab === "privacy" ? <Privacy /> : <SupportContactSettings />}
    </>
  );
};
